import { useEffect, useState } from "react";
import SoftBox from "components/SoftBox";
import Loader from "examples/Loader";
import "./style.css";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import Tabs from "../components/Tabs";
import ClaimRequest from "./components/Tabs/ClaimRequest";
import Tags from "./components/Tabs/Tags";
import NewTable from "./components/AccountTable";
import PageLayout from "examples/LayoutContainers/PageLayout";
import SoftTypography from "components/SoftTypography";
import breakpoints from "assets/theme/base/breakpoints";
import { Warning } from "@mui/icons-material";

function Accounts() {
  const { values } = breakpoints;
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const [tagsData, setTagsData] = useState([]);
  const [List, setList] = useState([]);
  const [claimBusinessData, setClaimBusinessData] = useState([]);
  const [loader, setloader] = useState(true);
  const [showWarning, setShowWarning] = useState(false);
  const [show, setShow] = useState(false);
  const onLoad = async () => {
    const { response } = await AppService.accounts.GetAccountsForAgency({
      query: `agency_id=${agency._id}&tags=business`,
      toaster: false,
    });
    if (response) {
      setList(response?.data || []);
      setloader(false);
      const anyMissingPlan = response?.data.some(
        (biz) => biz?.plan_type === "premium" && (!biz?.business_plan?.plan_id || !biz?.plan)
      );
      setShowWarning(anyMissingPlan);
    } else {
      setList([]);
      setloader(false);
    }
  };

  const getClaimeBusiness = async () => {
    const { response } = await AppService.claim_business.Get({
      query: `agency_id=${agency?._id}`,
    });
    if (response) {
      setClaimBusinessData(response?.data);
    }
  };

  async function fetchTags() {
    const response = await AppService.business_tags.get({
      query: `agency_id=${agency._id}`,
    });
    setTagsData(response?.response?.data || []);
  }

  useEffect(() => {
    onLoad();
    getClaimeBusiness();
  }, []);

  return loader ? (
    <Loader />
  ) : (
    <PageLayout>
      <SoftBox alignItems="center">
        <div
          className="d-flex w-100 align-items-center"
          style={{ justifyContent: "space-between" }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <SoftTypography
              variant={window.innerWidth < values.sm ? "h3" : "h2"}
              textTransform="capitalize"
              fontWeight="600"
            >
              Businesses
            </SoftTypography>
          </div>

          {showWarning && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                backgroundColor: "#ffe5e5",
                color: "#d32f2f",
                padding: "5px 12px",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "500",
                whiteSpace: "nowrap",
              }}
            >
              <Warning /> One or more premium accounts are not configured properly. Please assign a
              valid plan to all premium accounts to enable full functionality.
            </div>
          )}
          {/* 
  <div className="w-25 text-end">
    <CreateModal products={products} apps={apps} handleRefresh={onLoad} />
  </div> 
  */}
        </div>
        <Tabs
          tabsData={[
            {
              label: `All Accounts (${List?.length})`,
              content: <NewTable data={List} onLoad={onLoad} type="all"/>,
            },
            {
              label: `Premium Accounts (${
                List?.filter((item) => item?.plan_type === "premium")?.length
              })`,
              content: (
                <NewTable
                  onLoad={onLoad}
                  data={List?.filter((item) => item?.plan_type === "premium")}
                  type="premium"
                />
              ),
            },
            {
              label: `Free Accounts (${
                List?.filter((item) => item?.plan_type === "free")?.length
              })`,
              content: (
                <NewTable
                  onLoad={onLoad}
                  data={List?.filter((item) => item?.plan_type === "free")}
                  FreeAccount={List?.filter((item) => item?.plan_type === "free")}
                  type="free"
                />
              ),
            },
            {
              label: `Claim Requests (${
                claimBusinessData?.filter(
                  (item) => item?.request_type === "claim" && item.status === "pending"
                ).length || 0
              })`,
              content: <ClaimRequest type="claim" onLoad={onLoad} />,
            },
            {
              label: `New Business Requests (${
                claimBusinessData?.filter(
                  (item) => item?.request_type === "new" && item.status === "pending"
                ).length
              })`,
              content: <ClaimRequest type="new" onLoad={onLoad} />,
            },
            {
              label: `Labels (${tagsData?.length || 0})`,
              content: <Tags fetchData={fetchTags} tagsData={tagsData} />,
            },
          ]}
        />
      </SoftBox>
    </PageLayout>
  );
}

export default Accounts;
